import { novigAccounts, antNovigAccounts } from './novigAccounts';
const accountLabels = Object.fromEntries([...novigAccounts, ...antNovigAccounts].map(account => [account.id, account.name]));

export const accountLabel = account => accountLabels[account.id] || (account.name === 'Main wallet' ? 'Main Wallet' : account.name);
export const isVisibleAccount = account => account.name === 'Main wallet'
  || Boolean(accountLabels[account.id])
  || Number(account.cash) !== 0
  || Number(account.positionCost) !== 0
  || account.openPositions > 0
  || ['deposits', 'withdrawals', 'transfersIn', 'transfersOut'].some(field => Number(account.funding?.[field] || 0) !== 0);
